import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'Imperio Americano';
  }, []);
  return <LandingPage data-id="element-0" />;
}